import axios from 'axios'
import {GameGenericType} from '../models/response/GamePayload'
import client from '../client'

export function get() {
  return client.get<GameGenericType[]>(
    `/PrizeBreakDownTypes?PageNumber=1&PageSize=100`,
    {
      headers: {accept: 'application/json'},
    }
  )
}
